module.exports = __webpack_public_path__ + "static/media/1.bfc3c5d3.jpg";